import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portais',
  templateUrl: './portais.component.html',
  styleUrls: ['./portais.component.css']
})
export class PortaisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
